import CrudCustom from '../../../libs/custom/CrudCustom';

let LawanTransaksiPajakService = new CrudCustom('/lawan-transaksi-pajaks');
export default LawanTransaksiPajakService;
